<h3 mat-dialog-title>Editing Permissions for Group</h3>

<img mat-dialog-close class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content class="has-table">
    <p class="text-secondary text-center m-3">Active members will always have permissions to see their issued charges
        and pay them.</p>

    <form class="px-4 py-3" [formGroup]="adminForm" *ngIf="jwt.admin || jwt.superUser">
        <mat-slide-toggle
            (change)="toggleAdminStatus($event.checked)"
            formControlName="isAdmin"
        >
            <label>Admin status</label>
        </mat-slide-toggle>
    </form>

    <div class="row no-gutters">
        <div class="col-md-8">
            <table class="table permissions">
                <thead>
                <tr>
                    <th>Module</th>
                    <th>Read</th>
                    <th>Edit</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of moduleList">
                    <td [class.pl-5]="item.module.siteId === 4">{{stringService.PascalCase(item.module.name)}}</td>
                    <td>
                        <mat-checkbox [attr.data-module]="item.module.name"
                                      [attr.data-module-write]="0"
                                      (change)="changeModuleReadPermission(item, $event);"
                                      [checked]="item.memberCanRead"
                                      [disabled]="adminForm.get('isAdmin').value || item.module.disableRead"
                        ></mat-checkbox>
                    </td>
                    <td>
                        <mat-checkbox [attr.data-module]="item.module.name"
                                      [attr.data-module-write]="1"
                                      (change)="changeModuleWritePermission(item, $event);"
                                      [checked]="item.memberCanWrite"
                                      [disabled]="adminForm.get('isAdmin').value || item.module.disableWrite"
                        ></mat-checkbox>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="col-md-4 col-12 members">
            <table class="table permissions">
                <thead>
                <tr>
                    <th>Editing permissions for:</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <p *ngFor="let member of groupMembers">
                                 {{member.profile?.familyName}}, {{member.profile?.givenNames}}
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-dialog-close class="btn btn-outline-secondary">
        Cancel
    </button>
    <button
        [disabled]="isSaving"
        (click)="onSubmit()" class="btn btn-primary">
        Save
    </button>
</mat-dialog-actions>
